export default __webpack_public_path__ + "static/media/home.137d3275.svg";